import React from 'react';
import { Link } from 'react-router-dom';
import '../component_css/Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>Contact Us</h3>
          <p>Email: support@tayandtoscorporations.com</p>
          <p>Phone: +234 814 074 9365</p>
          <p>Phone: +234 803 843 6811</p>
          <p>Address: NO. 5, UNITY QUARTERS, FEDERAL PRISON AREA, OFF ARE/ AFAO ROAD, ADO-EKITI, EKITI STATE, NIGERIA</p>
        </div>
        <div className="footer-section">
          <h3>Quick Links</h3>
          <div className="quick-links">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms-conditions">Terms &amp; Conditions</Link>
          </div>
        </div>
        <div className="footer-section">
          <h3>Follow Us</h3>
          <div className="social-links">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">Facebook</a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">Twitter</a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">Instagram</a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} TayAndTos. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer; 